import { withBasketRootProps } from 'viewModel/rwdBasket/rwdBasketRoot/withBasketRootProps';
import RwdBasketRoot from 'components/RwdBasket/RwdBasketRoot/RwdBasketRoot';

export default withBasketRootProps(RwdBasketRoot);
